import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';
import { useRevealOnScroll } from '../../hooks/useRevealOnScroll';
import { DASHBOARD_LIST_VIEWPORT_CLASS } from '../../services/dashboard/ordreDuJour';

export function WidgetInfiniteList({
  itemCount,
  className,
  children,
}: {
  itemCount: number;
  className?: string;
  children: (visibleCount: number) => ReactNode;
}) {
  const { visibleCount, rootRef, sentinelRef, hasMore } = useRevealOnScroll(itemCount);

  return (
    <div ref={rootRef} className={cn(DASHBOARD_LIST_VIEWPORT_CLASS, className)}>
      {children(visibleCount)}
      {hasMore ? <div ref={sentinelRef} className="h-4" aria-hidden /> : null}
    </div>
  );
}
